import './App.scss';
import Navbar from './Components/Navbar/Navbar';
import Home from './Containers/Home/Home';
import { Routes, Route } from 'react-router-dom';
import AddArticle from './Containers/AddArticle/AddArticle';
import Contact from './Containers/Contact/Contact';
import Article from './Containers/Article/Article';
import NotFound from './Containers/NotFound/NotFound';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/write" element={<AddArticle />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/article/:title" element={<Article />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
}

export default App;
